import { getRefreshToken } from './tokens';
const AUTH_URL = import.meta.env.VITE_AUTH_URL;
export function redirectToAuth() {
    if (!AUTH_URL) {
        console.error('VITE_AUTH_URL not configured');
        return;
    }
    const lang = localStorage.getItem('user_language') || 'ru';
    const theme = localStorage.getItem('theme') || 'dark';
    const state = btoa(JSON.stringify({ service_name: 'AdminPanelUnfence' }));
    const params = new URLSearchParams({ state, lang, theme });
    const rt = getRefreshToken();
    if (rt)
        params.set('refresh_token', rt);
    window.location.href = `${AUTH_URL}?${params.toString()}`;
}
